import { render } from "./SidebarItem.vue?vue&type=template&id=38688a82"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"

import "./SidebarItem.vue?vue&type=style&index=0&id=38688a82&lang=css"

import exportComponent from "C:\\xampp8\\htdocs\\AI4IRGClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__